export default __webpack_public_path__ + "static/media/Frame 4.3825e3fb.jpg";